import styled from 'styled-components'

export const ContentPayment = styled.div`
  span {
    display: block;
  }
`
